import FileUploadAssistant from '@/helpers/file-upload-assistant'

// The API (or a proxy in front of it) turns away a request over its size limit, i.e. with a file that's too large
export default {
  notification: {
    message: FileUploadAssistant.tooLargeMessage(),
  },
}
